import React from "react";

import { DefaultInvestorPerson } from "../../graphicIcon";
import { IconDefaultCompanyImage } from "../../Icons";
import AvatarBackground from "../core/AvatarBackground/AvatarBackground";

interface Props {
  imageSize: number | string;
  containerSize: number;
  borderRadius?: string;
  logoUrl?: string | null;
  className?: string;
  imageComponent?: JSX.Element;
  isPerson?: boolean;
  // 지정 시 img 에 object-fit 적용. 비정사각 로고를 정사각 박스 안에서
  // 비율 유지(contain)할 때 사용. 미지정 시 기존 동작 유지.
  objectFit?: React.CSSProperties["objectFit"];
}

const CompanyImage = ({
  imageSize,
  containerSize,
  borderRadius,
  logoUrl,
  className,
  imageComponent,
  isPerson,
  objectFit,
}: Props) => {
  const isValidLogoUrl = (url: string | null | undefined): boolean => {
    if (!url || url.trim() === "") return false;
    try {
      const urlObj = new URL(url);
      return urlObj.protocol === "http:" || urlObj.protocol === "https:";
    } catch {
      return false;
    }
  };

  const isHaveImageComponent = imageComponent && imageComponent?.props.src;
  const hasValidLogoUrl = isValidLogoUrl(logoUrl);

  const isNotHaveImage = !hasValidLogoUrl && !isHaveImageComponent;

  const isPersonImage = isNotHaveImage && isPerson;

  const returnCompanyLogoComponent = () => {
    if (isPersonImage) return <DefaultInvestorPerson />;

    if (isNotHaveImage) return <IconDefaultCompanyImage />;

    if (isHaveImageComponent) return imageComponent;

    if (hasValidLogoUrl && logoUrl)
      return (
        <img
          src={logoUrl}
          alt="company logo"
          width={imageSize}
          height={imageSize}
          style={objectFit ? { objectFit } : undefined}
        />
      );

    return <IconDefaultCompanyImage />;
  };

  return (
    <AvatarBackground
      containerSize={`${containerSize / 10}rem`}
      borderRadius={borderRadius}
      className={className}
    >
      <>{returnCompanyLogoComponent()}</>
    </AvatarBackground>
  );
};

export default CompanyImage;
